/**
 * Composant pour afficher une liste de rendez-vous
 */
import React from 'react';
import { Link } from 'react-router-dom';
import { Appointment } from '../types';
import AppointmentCard from './AppointmentCard';

interface AppointmentListProps {
  title: string;
  appointments: Appointment[];
  emptyMessage: string;
  limit?: number;
  showContactInfo?: boolean;
  showTypeInfo?: boolean;
  showViewAllLink?: boolean;
  viewAllLink?: string;
}

/**
 * Composant pour afficher une liste de rendez-vous
 */
const AppointmentList: React.FC<AppointmentListProps> = ({
  title,
  appointments,
  emptyMessage,
  limit,
  showContactInfo = true,
  showTypeInfo = false,
  showViewAllLink = false,
  viewAllLink = '/appointments'
}) => {
  // Limiter le nombre de rendez-vous affichés si nécessaire
  const displayedAppointments = limit ? appointments.slice(0, limit) : appointments;

  return (
    <div className="dashboard-section">
      <h2>{title}</h2>
      {appointments.length === 0 ? (
        <p>{emptyMessage}</p>
      ) : (
        <div className="appointment-list">
          {displayedAppointments.map(appointment => (
            <AppointmentCard 
              key={appointment.id}
              appointment={appointment}
              showContactInfo={showContactInfo}
              showTypeInfo={showTypeInfo}
            />
          ))}
        </div>
      )}
      {showViewAllLink && appointments.length > (limit || 0) && (
        <div className="view-all">
          <Link to={viewAllLink} className="btn btn-link">
            Voir tous les rendez-vous
          </Link>
        </div>
      )}
    </div>
  );
};

export default AppointmentList;
